import {Helmet} from "react-helmet";
import React from "react";
import {Link} from "react-router-dom";
import {getGeneratedRoute, RouteEnumFinal} from "../../Config/RouteEnum";
import {BASE_URL} from "../../Config/SharedConfig";
import {getStoreName} from "../../Components/Utils/getStoreName";
import CategoryProductSlider from "../../Components/Store/ui/CategoryProductSlider";
import FloatingButtons from "../../Components/Store/ui/FloatingButtons";


const Homepage = (
    {
        store,
        isFetching
    }
) => {
    const theme = store?.theme

    if (isFetching) return (
        <div className="shimmer-container">
            <div className="container">
                <div className="row mt-56">
                    <div className="col-auto">
                        <div className='avatar-cnt-100 shimmer'/>
                    </div>
                    <div className='col'>
                        <div className='line-title shimmer mt-8'/>
                        <div className='line-paragraph shimmer mt-12'/>
                        <div className='line-paragraph shimmer mt-12'/>
                    </div>
                </div>
                <div className='row mt-20'>
                    <div className='col-auto'>
                        <div className='tab shimmer'/>
                    </div>
                    <div className='col-auto'>
                        <div className='tab shimmer'/>
                    </div>
                    <div className='col-auto'>
                        <div className='tab shimmer'/>
                    </div>
                    <div className='col-auto'>
                        <div className='tab shimmer'/>
                    </div>
                    <div className='col-auto'>
                        <div className='tab shimmer'/>
                    </div>
                </div>
                <div className='row g-3 mt-24'>
                    <div className='col-6'>
                        <div>
                            <div className='square-box shimmer'>
                                <div/>
                            </div>
                            <div className='line-title shimmer mt-8'/>
                            <div className='line-paragraph shimmer mt-8'/>
                            <div className='line-paragraph shimmer mt-8'/>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div>
                            <div className='square-box shimmer'>
                                <div/>
                            </div>
                            <div className='line-title shimmer mt-8'/>
                            <div className='line-paragraph shimmer mt-8'/>
                            <div className='line-paragraph shimmer mt-8'/>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div>
                            <div className='square-box shimmer'>
                                <div/>
                            </div>
                            <div className='line-title shimmer mt-8'/>
                            <div className='line-paragraph shimmer mt-8'/>
                            <div className='line-paragraph shimmer mt-8'/>
                        </div>
                    </div>
                    <div className='col-6'>
                        <div>
                            <div className='square-box shimmer'>
                                <div/>
                            </div>
                            <div className='line-title shimmer mt-8'/>
                            <div className='line-paragraph shimmer mt-8'/>
                            <div className='line-paragraph shimmer mt-8'/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

    return (
        <>
            <Helmet>
                <title>{` دیجیلوگ | ${store?.title ?? ""}`}</title>
                <meta name="description" content={store?.description}/>
                <meta name="theme-color" content={theme?.primaryColor}/>
                {
                    store?.metaOG?.map(meta => {
                        return (
                            <meta key={meta._id} property={meta.property} content={meta.content}/>
                        )
                    })
                }
            </Helmet>

            {/*header*/}
            <section className='store-header pb-18' style={{backgroundColor: theme?.primaryColor}}>
                <section className='navbar-top'>
                    {/*toolbar icons*/}
                    <div className='container'>
                        <div className='row justify-content-between'>
                            {/*<div className='col-auto'>
                                    <div className='img-cnt-24'>
                                        <img src={"/assets/images/vectors/search_white.svg"}/>
                                    </div>
                                </div>
                                {
                                    this.state.store.isOwner
                                        ? <div className='col-auto'>
                                            <div className='row'>
                                                <div className='col-auto'>
                                                    <div className='img-cnt-24'>
                                                        <img src={"/assets/images/vectors/chart_white.svg"}/>
                                                    </div>
                                                </div>
                                                <div className='col-auto'>
                                                    <div className='img-cnt-24'>
                                                        <img src={"/assets/images/vectors/setting_white.svg"}/>
                                                    </div>
                                                </div>
                                            </div>
                                          </div>
                                        : ''
                                }*/}
                        </div>
                    </div>
                </section>
                <div className='container mt-custom-4'>
                    <div className='row'>
                        <div className='col-auto'>
                            {
                                store?.isOwner
                                    ? (<Link
                                        to={getGeneratedRoute(RouteEnumFinal.STORE_GALLERY_URL_GENERATE, getStoreName())}
                                        className='td-none'>
                                        <div className='avatar-cnt-100'>
                                            <img
                                                alt="avatar"
                                                src={store?.avatar === null ? "/assets/images/statics/avatar.png" : (BASE_URL + store?.avatar.internalPath)}/>
                                        </div>
                                    </Link>)
                                    : (<div className='avatar-cnt-100'>
                                        <img
                                            alt="avatar"
                                            src={store?.avatar === null ? "/assets/images/statics/avatar.png" : (BASE_URL + store?.avatar.internalPath)}/>
                                    </div>)
                            }
                        </div>
                        <div className='col'>
                            <div className='mobile-h3' style={{color: theme?.primaryTextColor}}>
                                {store?.title}
                            </div>
                            <div className='mobile-subtitle-regular mt-8'
                                 style={{color: theme?.primaryTextColor}}>
                                {store?.description}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/*Tabs*/}
            <CategoryProductSlider
                primaryColor={theme?.primaryColor}
                listType={store?.listType ?? "grid"}
            />

            <div className="scroll-fixer"></div>

            <FloatingButtons />

        </>
    )
}

export default Homepage